export default __webpack_public_path__ + "static/media/pause.8a736f3f.svg";